import React from 'react';
import Pagination from 'react-bootstrap/Pagination';

const Paginator = ({ currentPage, pageSize, totalItems, handlePageClick }) => {
  const totalPages = Math.ceil(totalItems / pageSize);
  const halfPageList = 5; // Show a maximum of 5 pages at a time

  const getPageNumbers = () => {
    let startPage, endPage;

    // Check if there are more than 10 pages
    if (totalPages > 10) {
      // Calculate the start and end pages
      if (currentPage <= halfPageList) {
        startPage = 0;
        endPage = halfPageList * 2;
      } else if (currentPage + halfPageList >= totalPages - 1) {
        startPage = totalPages - halfPageList * 2 - 1;
        endPage = totalPages - 1;
      } else {
        startPage = currentPage - halfPageList;
        endPage = currentPage + halfPageList;
      }
    } else {
      startPage = 0;
      endPage = totalPages - 1;
    }

    // Create an array of page numbers
    return Array.from({ length: endPage - startPage + 1 }, (_, i) => startPage + i);
  };

  const pageNumbers = getPageNumbers();

  return (
    <Pagination>
      <Pagination.First onClick={() => handlePageClick(0)} disabled={currentPage === 0} />
      <Pagination.Prev onClick={() => handlePageClick(currentPage - 1)} disabled={currentPage === 0} />
      {pageNumbers.map((page) => (
        <Pagination.Item
          key={page}
          active={currentPage === page}
          onClick={() => handlePageClick(page)}
        >
          {page + 1}
        </Pagination.Item>
      ))}
      <Pagination.Next onClick={() => handlePageClick(currentPage + 1)} disabled={currentPage === totalPages - 1} />
      <Pagination.Last onClick={() => handlePageClick(totalPages - 1)} disabled={currentPage === totalPages - 1} />
    </Pagination>
  );
};

export default Paginator;
